/**
 * Monster Cart Translation for Langify (React-compatible version)
 * This script detects Langify language changes and translates Monster Cart drawer text
 * Compatible with React-based Monster Cart drawer
 */

(function() {
  // Define your translations here - Add more translations as needed
  const translations = {
    fr: {
      'votre panier': 'votre panier',
      'Ajouter au panier': 'Ajouter au panier',
      'ajouter au panier': 'ajouter au panier',
      'Sous-total': 'Sous-total',
      'Continuer Magasinage': 'Continuer Magasinage',
      'Voir le panier': 'Voir le panier',
      'Paiement': 'Paiement',
      'Commander': 'Commander',
      'Panier': 'Panier',
      'Votre panier est vide': 'Votre panier est vide',
      'Livraison': 'Livraison',
      'Total': 'Total',
      'Supprimer': 'Supprimer',
      'Quantité': 'Quantité',
      'code de coupon': 'code de coupon',
      'fréquemment achetés ensemble': 'fréquemment achetés ensemble',
      'Ou 4 paiements de': 'Ou 4 paiements de',
      'avec': 'avec',
      'show details': 'show details',
      'Ajouter': 'Ajouter',
      'Voir les détails': 'Voir les détails',
      'Détails': 'Détails',
      'Ajouter tous au panier': 'Ajouter tous au panier',
      'Total:': 'Total:',
      'Économisez': 'Économisez',
      'Articles fréquemment achetés ensemble': 'Articles fréquemment achetés ensemble',
      'Produits recommandés': 'Produits recommandés',
      'Atteint': 'Atteint',
      'obtiens un produit gratuit': 'obtiens un produit gratuit',
      'obtiens un produit gratuit🎁': 'obtiens un produit gratuit🎁',
      'ajoutez': 'ajoutez',
      'pour débloquer Cadeau Gratuit': 'pour débloquer Cadeau Gratuit',
      'Cadeau Gratuit': 'Cadeau Gratuit',
      'OU': 'OU',
      'entrez le coupon': 'entrez le coupon',
      'appliquer': 'appliquer',
      'fermer': 'fermer',
      'Gratuit': 'Gratuit',
      'afficher les détails': 'afficher les détails',
      'sécurisé et garanti': 'sécurisé et garanti',
      'Retour au panier': 'Retour au panier'
    },
    en: {
      'votre panier': 'your cart',
      'Ajouter au panier': 'Add to cart',
      'ajouter au panier': 'add to cart',
      'Sous-total': 'Subtotal',
      'Continuer Magasinage': 'Continue Shopping',
      'Voir le panier': 'View cart',
      'Paiement': 'Checkout',
      'Commander': 'Checkout',
      'Panier': 'Cart',
      'Votre panier est vide': 'Your cart is empty',
      'Livraison': 'Shipping',
      'Total': 'Total',
      'Supprimer': 'Remove',
      'Quantité': 'Quantity',
      'code de coupon': 'coupon code',
      'fréquemment achetés ensemble': 'frequently bought together',
      'Ou 4 paiements de': 'Or 4 payments of',
      'avec': 'with',
      'show details': 'show details',
      'Ajouter': 'Add',
      'Voir les détails': 'View details',
      'Détails': 'Details',
      'Ajouter tous au panier': 'Add all to cart',
      'Total:': 'Total:',
      'Économisez': 'Save',
      'Articles fréquemment achetés ensemble': 'Frequently bought together items',
      'Produits recommandés': 'Recommended products',
      'Atteint': 'Reach',
      'obtiens un produit gratuit': 'get a free product',
      'obtiens un produit gratuit🎁': 'get a free product🎁',
      'ajoutez': 'add',
      'pour débloquer Cadeau Gratuit': 'to unlock your Free Gift',
      'Cadeau Gratuit': 'Free Gift',
      'OU': 'OR',
      'entrez le coupon': 'enter coupon',
      'appliquer': 'apply',
      'fermer': 'close',
      'Gratuit': 'Free',
      'afficher les détails': 'show details',
      'sécurisé et garanti': 'secure and guaranteed',
      'Retour au panier': 'Back to Cart'
    }
  };

  // Function to get current Langify language from URL path
  function getCurrentLanguage() {
    // Check if URL contains /en/ or starts with /en
    const path = window.location.pathname;
    if (path.startsWith('/en') || path.includes('/en/')) {
      return 'en';
    }
    // Default to French
    return 'fr';
  }

  // Function to translate Monster Cart elements (React-compatible)
  function translateMonsterCart() {
    const currentLang = getCurrentLanguage();
    const langTranslations = translations[currentLang] || translations.fr;

    console.log('Monster Cart Translation: Current language detected as', currentLang);

    // Function to fetch translated product title from product page
    async function fetchTranslatedProductTitle(productUrl, lang) {
      try {
        // Construct the translated URL
        let translatedUrl = productUrl;
        if (lang === 'en' && !productUrl.includes('/en/')) {
          translatedUrl = productUrl.replace('/products/', '/en/products/');
        } else if (lang === 'fr' && productUrl.includes('/en/')) {
          translatedUrl = productUrl.replace('/en/products/', '/products/');
        }

        const response = await fetch(translatedUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Try multiple selectors to find the product title
        const titleSelectors = [
          'h1.product-title',
          'h1[class*="product"]',
          '.product__title',
          '[data-product-title]',
          'meta[property="og:title"]'
        ];

        for (const selector of titleSelectors) {
          const titleElement = doc.querySelector(selector);
          if (titleElement) {
            if (selector.includes('meta')) {
              return titleElement.getAttribute('content');
            }
            return titleElement.textContent.trim();
          }
        }

        // Fallback: try to find any h1 on the page
        const h1 = doc.querySelector('h1');
        if (h1) {
          return h1.textContent.trim();
        }

        return null;
      } catch (error) {
        console.error('Error fetching translated product title:', error);
        return null;
      }
    }

    // Function to translate product titles in Frequently Bought Together
    async function translateProductTitles() {
      if (currentLang === 'fr') {
        // Don't translate if we're on French version
        return;
      }

      // Find all product links in the cart drawer
      const productLinks = document.querySelectorAll('[class*="fbt"] a[href*="/products/"], [class*="frequently"] a[href*="/products/"], .mu-fbt-item a[href*="/products/"]');
      
      console.log('Found', productLinks.length, 'product links to translate');

      for (const link of productLinks) {
        const productUrl = link.href;
        
        // Translate the URL itself to include /en/
        if (currentLang === 'en' && !productUrl.includes('/en/')) {
          const translatedUrl = productUrl.replace('/products/', '/en/products/');
          link.href = translatedUrl;
          console.log('Updated link URL to:', translatedUrl);
        }
        
        // Find the title element (usually next to or inside the link)
        let titleElement = link.querySelector('[class*="title"]');
        if (!titleElement) {
          titleElement = link.closest('[class*="item"]')?.querySelector('[class*="title"]');
        }
        if (!titleElement && link.textContent.trim().length > 10) {
          // The link itself might contain the title
          titleElement = link;
        }

        if (titleElement && productUrl.includes('/products/')) {
          console.log('Translating product:', productUrl);
          const translatedTitle = await fetchTranslatedProductTitle(productUrl, currentLang);
          
          if (translatedTitle) {
            console.log('Translated title:', translatedTitle);
            // Find the text node and replace it
            const textNodes = [];
            const walker = document.createTreeWalker(
              titleElement,
              NodeFilter.SHOW_TEXT,
              null,
              false
            );
            let node;
            while (node = walker.nextNode()) {
              if (node.textContent.trim().length > 5) {
                textNodes.push(node);
              }
            }
            
            if (textNodes.length > 0) {
              textNodes[0].textContent = translatedTitle;
            } else if (titleElement.childNodes.length > 0) {
              titleElement.childNodes[0].textContent = translatedTitle;
            }
          }
        }
      }
    }

    // Function to translate text in an element
    function translateText(element) {
      if (!element) return;

      // Get all text nodes
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      const textNodes = [];
      let node;
      while (node = walker.nextNode()) {
        textNodes.push(node);
      }

      // Translate each text node
      textNodes.forEach(textNode => {
        if (textNode.textContent && textNode.textContent.trim()) {
          let originalText = textNode.textContent;
          let translatedText = originalText;

          // Sort translations by length (longest first) to avoid partial replacements
          const sortedKeys = Object.keys(translations.fr).sort((a, b) => b.length - a.length);

          // Check for matches
          sortedKeys.forEach(frenchText => {
            if (translatedText.includes(frenchText)) {
              const englishText = langTranslations[frenchText] || frenchText;
              // Use a simple replace to handle all occurrences
              translatedText = translatedText.split(frenchText).join(englishText);
            }
          });

          if (originalText !== translatedText) {
            textNode.textContent = translatedText;
          }
        }
      });

      // Also check for common attributes
      const elementsWithText = element.querySelectorAll('[placeholder], [aria-label], [title], button, a, span, div, p, h1, h2, h3, h4, h5, h6');
      elementsWithText.forEach(el => {
        // Translate placeholder
        if (el.placeholder) {
          Object.keys(translations.fr).forEach(frenchText => {
            if (el.placeholder.includes(frenchText)) {
              el.placeholder = el.placeholder.replace(
                new RegExp(frenchText, 'gi'),
                langTranslations[frenchText] || frenchText
              );
            }
          });
        }

        // Translate aria-label
        if (el.getAttribute('aria-label')) {
          let ariaLabel = el.getAttribute('aria-label');
          Object.keys(translations.fr).forEach(frenchText => {
            if (ariaLabel.includes(frenchText)) {
              ariaLabel = ariaLabel.replace(
                new RegExp(frenchText, 'gi'),
                langTranslations[frenchText] || frenchText
              );
            }
          });
          el.setAttribute('aria-label', ariaLabel);
        }

        // Translate title attribute
        if (el.getAttribute('title')) {
          let title = el.getAttribute('title');
          Object.keys(translations.fr).forEach(frenchText => {
            if (title.includes(frenchText)) {
              title = title.replace(
                new RegExp(frenchText, 'gi'),
                langTranslations[frenchText] || frenchText
              );
            }
          });
          el.setAttribute('title', title);
        }
      });
    }

    // Wait for Monster Cart drawer to be available and translate it
    function findAndTranslateDrawer() {
      // Multiple possible selectors for Monster Cart drawer
      const possibleSelectors = [
        '[data-monster-cart]',
        '.monster-cart',
        '#monster-cart-drawer',
        '[id*="monster"]',
        '[class*="monster"]',
        '[data-cart-drawer]',
        '.cart-drawer',
        '#cart-drawer',
        // More generic cart drawer selectors
        '[role="dialog"][aria-label*="cart" i]',
        '[role="dialog"][aria-label*="panier" i]'
      ];

      let drawer = null;
      for (const selector of possibleSelectors) {
        drawer = document.querySelector(selector);
        if (drawer) {
          console.log('Monster Cart drawer found with selector:', selector);
          break;
        }
      }

      if (drawer) {
        translateText(drawer);

        // Also translate product titles by fetching from translated pages
        translateProductTitles();

        // Set up mutation observer for React re-renders
        const observer = new MutationObserver((mutations) => {
          translateText(drawer);
          // Re-translate products when content changes
          translateProductTitles();
        });

        observer.observe(drawer, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: false
        });

        return true;
      }

      return false;
    }

    // Try to find and translate immediately
    if (findAndTranslateDrawer()) {
      return;
    }

    // If not found, keep checking periodically
    let attempts = 0;
    const maxAttempts = 50; // Try for 5 seconds
    const checkInterval = setInterval(() => {
      attempts++;
      if (findAndTranslateDrawer() || attempts >= maxAttempts) {
        clearInterval(checkInterval);
      }
    }, 100);
  }

  // Run translation on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateMonsterCart);
  } else {
    translateMonsterCart();
  }

  // Re-translate when cart is opened or updated
  // Listen for any cart-related events
  const cartEvents = ['cart:open', 'cart:updated', 'cart:refresh', 'drawer:open'];
  cartEvents.forEach(eventName => {
    document.addEventListener(eventName, () => {
      console.log('Cart event detected:', eventName);
      setTimeout(translateMonsterCart, 100);
      setTimeout(translateMonsterCart, 500);
    });
  });

  // Listen for clicks on cart icon or add to cart buttons
  document.addEventListener('click', (e) => {
    const target = e.target.closest('a, button');
    if (target && (
      target.getAttribute('href')?.includes('cart') ||
      target.className?.includes('cart') ||
      target.id?.includes('cart') ||
      target.getAttribute('data-cart') ||
      target.textContent?.toLowerCase().includes('cart') ||
      target.textContent?.toLowerCase().includes('panier')
    )) {
      console.log('Cart-related click detected');
      setTimeout(translateMonsterCart, 200);
      setTimeout(translateMonsterCart, 500);
      setTimeout(translateMonsterCart, 1000);
    }
  });

  // Listen for form submissions (add to cart)
  document.addEventListener('submit', (e) => {
    if (e.target.querySelector('[name="add"]') || e.target.querySelector('[name="id"]')) {
      console.log('Add to cart form submitted');
      setTimeout(translateMonsterCart, 500);
      setTimeout(translateMonsterCart, 1000);
    }
  });

  // Watch for any new dialogs or modals appearing
  const bodyObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          const element = node;
          // Check if this might be a cart drawer
          if (
            element.getAttribute('role') === 'dialog' ||
            element.classList?.contains('cart') ||
            element.classList?.contains('drawer') ||
            element.id?.includes('cart') ||
            element.id?.includes('drawer')
          ) {
            console.log('New dialog/drawer detected, translating');
            setTimeout(translateMonsterCart, 100);
          }
        }
      });
    });
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also re-translate periodically when cart is visible (last resort)
  setInterval(() => {
    const drawer = document.querySelector('[role="dialog"][aria-label*="cart" i], [role="dialog"][aria-label*="panier" i], [data-monster-cart], .monster-cart');
    if (drawer && drawer.offsetParent !== null) { // Check if visible
      translateMonsterCart();
    }
  }, 2000);

})();